import { render } from "./NoShowReport.vue?vue&type=template&id=5647dd70&scoped=true"
import script from "./NoShowReport.vue?vue&type=script&lang=js"
export * from "./NoShowReport.vue?vue&type=script&lang=js"

import "./NoShowReport.vue?vue&type=style&index=0&id=5647dd70&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5647dd70"]])

export default __exports__